import Vue from 'vue'
import ElementUI from 'element-ui'
import VueParticles from 'vue-particles'
import VueMeta from 'vue-meta'
import BaiduMap from 'vue-baidu-map'
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/swiper.min.css'
import '@/styles/index.css'

let installed = false

export function installCommonPlugins(options = {}) {
  if (installed) {
    return
  }

  const {
    enableMeta = true,
    enableParticles = true,
    enableBaiduMap = true
  } = options

  if (enableMeta) {
    Vue.use(VueMeta)
  }
  Vue.use(ElementUI)
  if (enableParticles) {
    Vue.use(VueParticles)
  }
  if (enableBaiduMap) {
    Vue.use(BaiduMap, {
      ak: 'http://api.map.baidu.com/api?v=2.0&ak=oNO23OgmZzC6RgjqGtYRsEC6'
    })
  }

  installed = true
}
